import { gql } from "apollo-boost";

export const GET_ALLERGY_GROUPS = gql`
  query getAllergyGroup($where: AllergyGroupWhereInput, $relations: [String]) {
    getAllergyGroup(where: $where, relations: $relations) {
      id
      name
    }
  }
`;

export const GET_MOLECULES = gql`
  query molecules($where: MoleculeWhereInput) {
    molecules(where: $where) {
      id
      name
    }
  }
`;